module.exports = __webpack_public_path__ + "img/uk-tuberculosis-female.dfe88e1f.png";